import { ContactPersonModel } from "./ContactPersonModel";


export class MembershipFormModel{
    contactPerson: ContactPersonModel[];
    companyServices: string[];
    companyName: string;
    companyEmail: string;
    companyLogo: string;
    primaryPhoneNumber: string;
    secondaryPhoneNumber: string;
    websiteUrl: string;
    accountingEmail: string;
    addressLine1: string;
    addressLine2: string;
    cityId: number;
    stateId: number;
    countryId: number;
    zipCode: string;
    companyDetails: string;
    instagramUrl: string;
    linkedinUrl: string;
    twitterUrl: string;
    facebookUrl: string;
    youtubeUrl: string;
    membershipType: string;
    attachment:string

    constructor(){
        this.contactPerson = [];
        this.companyServices = [];
        this.companyName="";
        this.companyEmail="";
        this.companyLogo = "";
        this.primaryPhoneNumber="";
        this.secondaryPhoneNumber="";
        this.websiteUrl="";
        this.accountingEmail="";
        this.addressLine1="";
        this.addressLine2="";
        this.cityId=0;
        this.stateId=0;
        this.countryId=0;
        this.zipCode="";
        this.companyDetails="";
        this.instagramUrl="";
        this.linkedinUrl="";
        this.twitterUrl="";
        this.facebookUrl="";
        this.youtubeUrl="";
        this.membershipType=""
        this.attachment=""
    }
}